import axios from "axios";

// Установка базового URL для всех запросов через Axios
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// Production uses the current origin, including the legacy domain during migration.
const baseURL = isLocal ? "http://localhost:8002" : window.location.origin;

// Создаем экземпляр Axios с базовым URL
const api = axios.create({
  baseURL: baseURL + "/api",
});

// Счётчик активных запросов для глобального loading
let activeRequestCount = 0;
let loadingCallbacks = {
  start: null,
  stop: null,
};

// Функция для регистрации callbacks загрузки
export const setLoadingCallbacks = (start, stop) => {
  loadingCallbacks.start = start;
  loadingCallbacks.stop = stop;
};

// Добавляем перехватчик для запросов - автоматически добавляем токен авторизации
api.interceptors.request.use(
  (config) => {
    // Показываем глобальный loading (кроме некоторых эндпоинтов)
    const skipLoading =
      config.skipLoading ||
      config.url?.includes("/avito-chats/unread-count") ||
      config.url?.includes("/user-theme");

    if (!skipLoading && loadingCallbacks.start) {
      activeRequestCount++;
      if (activeRequestCount === 1) {
        loadingCallbacks.start();
      }
    }
    config._skipLoading = skipLoading;

    // Автоматически добавляем токен авторизации к каждому запросу
    const token = config.isolatedAuth ? config.authToken : localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Добавляем глобальный перехватчик ответов
api.interceptors.response.use(
  (response) => {
    // Скрываем loading
    if (!response.config._skipLoading && loadingCallbacks.stop) {
      activeRequestCount = Math.max(0, activeRequestCount - 1);
      if (activeRequestCount === 0) {
        loadingCallbacks.stop();
      }
    }
    return response;
  },
  (error) => {
    // Скрываем loading при ошибке
    if (!error.config?._skipLoading && loadingCallbacks.stop) {
      activeRequestCount = Math.max(0, activeRequestCount - 1);
      if (activeRequestCount === 0) {
        loadingCallbacks.stop();
      }
    }
    // Ошибки валидации (400, 422) не логируем — они обрабатываются компонентами
    const status = error.response?.status;
    const isValidationError = status === 400 || status === 422;

    if (typeof window !== "undefined" && !isValidationError && !error.config?.isolatedAuth) {
      // Импортируем динамически, чтобы избежать циклических зависимостей
      import("../../services/ErrorService").then(
        ({ default: errorService }) => {
          errorService.handleApiError(error);
        },
      );
    }

    // Возвращаем ошибку для дальнейшей обработки компонентами
    return Promise.reject(error);
  },
);

export const getTableConfigs = async (businessTypeId) => {
  const response = await api.get(`/table-configs/${businessTypeId}`);
  return response.data;
};

export const getBusinessTypeModules = async (key) => {
  const response = await api.get(`/admin/business-types/${key}/modules`);
  return response.data.modules;
};

export default api;
